module.exports = __webpack_public_path__ + "img/phone.b1dedebe.svg";